import NotFoundPresenter from './NotFoundPresenter';
export default NotFoundPresenter;
